const ALLOWED_URL_PROTOCOLS = ['http:', 'https:', 'mailto:']

const parseAllowedUrl = (url: string) => {
  const trimmed = url.trim()
  if (!trimmed) return

  try {
    const withProtocol = /^[a-zA-Z][a-zA-Z\d+.-]*:/.test(trimmed)
      ? trimmed
      : `https://${trimmed}`
    const parsed = new URL(withProtocol)
    if (!ALLOWED_URL_PROTOCOLS.includes(parsed.protocol)) return
    return { trimmed, href: parsed.href }
  } catch {
    return
  }
}

export const sanitizeEntityUrl = (url: string): string | undefined => {
  return parseAllowedUrl(url)?.trimmed
}

export const normalizeLinkHref = (url: string): string | undefined => {
  return parseAllowedUrl(url)?.href
}
